import { Component, HostListener, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SidenavService } from '../../sidenav/sidenav.service';
import { PlatformGlobalService } from '../../service/platform-global.service';
import { DashboardService } from 'src/app/pages/dashboard/service/dashboard.service';

import { LanguageSelectorModel } from 'src/@prep/shared/language-selector/model/language-selector.model';
import { LanguageSelectorService } from 'src/@prep/shared/language-selector/service/language-selector.service';
import { TopToolbarTextDataEN } from '../toolbar-multi-lang/en-US';
import { TopToolbarTextDataES } from '../toolbar-multi-lang/es-EU';
import { TopToolbarTextDataIT } from '../toolbar-multi-lang/it-IT';

@Component({
  selector: 'prep-toolbar-user',
  templateUrl: './toolbar-user.component.html',
  styleUrls: ['./toolbar-user.component.scss'],
})
export class ToolbarUserComponent implements OnInit {
  isOpen: boolean;

  selectedLang: LanguageSelectorModel =
    this.languageSelectorService.getCurrentLanguage();
  LangTextData: any;
  constructor(
    private router: Router,
    private platformGlobalService: PlatformGlobalService,
    private dashboardService: DashboardService,
    private sidenavService: SidenavService,
    private languageSelectorService: LanguageSelectorService
  ) {
    this.languageSelectorService.language$.subscribe((lang) => {
      this.selectedLang = lang;
      console.log(
        '🌍 Language changed:',
        lang,
        lang.code,
        this.selectedLang.code
      );
      switch (this.selectedLang.code) {
        case 'en': {
          this.LangTextData = TopToolbarTextDataEN;
          console.log('🌍 English Language:', this.LangTextData);
          break;
        }
        case 'es': {
          this.LangTextData = TopToolbarTextDataES;
          console.log('🌍 English Language:', this.LangTextData);
          break;
        }
        case 'it': {
          this.LangTextData = TopToolbarTextDataIT;
          console.log('🌍 English Language:', this.LangTextData);
          break;
        }
        default: {
          this.LangTextData = TopToolbarTextDataEN;
          console.log('🌍 Default Language:', this.LangTextData);
          break;
        }
      }
    });
  }

  @HostListener('document:keydown', ['$event'])
  onKeydown(event: KeyboardEvent) {
    // console.log('open status', this.isOpen);

    if (event.key === 'Escape' && this.isOpen) {
      console.log('Escape key pressed resources');
      // Close the dropdown menu and focus the button

      const button = document.getElementById('user-menu-button');
      if (button) {
        button.focus();
      }

      this.closeDropdown();
    }
  }

  ngOnInit() { }

  toggleDropdown() {
    this.isOpen = !this.isOpen;
  }

  onClickOutside() {
    this.isOpen = false;
  }

  logoutClicked() {
    console.log('User Info toolbar', this.platformGlobalService.getCUserinfo);
    if (this.platformGlobalService.getCUserinfo.email) {
      const accEmail = this.platformGlobalService.getCUserinfo.email;
      const accDomain = accEmail.replace(/.*@/, "");
      console.log("Domain Info", accDomain);
      if (accDomain === 'stanford.edu') {
        localStorage.removeItem('token');
        localStorage.removeItem('account');
        this.sidenavService.items = [];
        window.location.replace('https://stanford.prep.continualengine.com/login');
      } else {
        let sendUserInfo = {
          username: this.platformGlobalService.getCUserinfo.email,
        };

        this.dashboardService.logoutCuncurrentUser(sendUserInfo).subscribe(
          (response) => {
            if (response.msg) {
              localStorage.removeItem('token');
              localStorage.removeItem('account');
              this.sidenavService.items = [];
              this.router.navigate(['/login']);
            }
          },
          (error) => {
            console.log('error', error);
            localStorage.removeItem('token');
            localStorage.removeItem('account');
            this.sidenavService.items = [];
            this.router.navigate(['/login']);
          }
        );
      }
    }
  }
  profile() {
    console.log('welcome to profile');
    this.router.navigate(['/profile']);
  }

  // Called on Escape key press
  closeDropdown() {
    this.isOpen = false;
  }

  // Called when focus leaves the dropdown menu
  onFocusOut(event: FocusEvent) {
    const relatedTarget = event.relatedTarget as HTMLElement;
    const menu = document.getElementById('user-menu');

    // If focus moved outside the dropdown, close it
    if (menu && relatedTarget && !menu.contains(relatedTarget)) {
      this.isOpen = false;
    }
  }
}
